import { Injectable } from '@angular/core';
import { RegionData } from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { of } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FlyoutLangSelectorHelperFacade } from './flyout-lang-selector-helper.facade';

@Injectable({
  providedIn: 'root'
})
export class FlyoutLangSelectorFacade extends FlyoutLangSelectorHelperFacade {
  init(): void {
    if (this.appconfig.onBrowser) {
      this.deviceTypes = this._deviceTypeHelper.getDeviceType();
    }
    this.countryLangSvc.getCountryLanguageData().subscribe((data) => {
      this.countryLanguageHelper.setData(data);
      this.countryLanguageList =
        this.countryLanguageHelper.getCountryLanguageList();
      this.regionList = this.countryLanguageHelper.getRegionList();
      this.searchRegionList = this.regionList;
      const countryCode =
        this.countryLanguageHelper.getCountryCodeFromPrefCookie();
      this.setSelectedRegion(countryCode);
      if (this.selectedRegion) {
        for (let i = 0; i < this.searchRegionList.length; i++) {
          this.setListIndex(i);
        }
        this.onRegionClicked({
          region: this.selectedRegion,
          flow: '',
          count: this.listIndex
        });
      }
      this.setClsValues(
        this.applicationConfig.getConfig('HEADER')?.['APP_PREF_COOKIE'] ||
          'en-us'
      );
      this.countryLanguageHelper
        .getPreferredLanguages()
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((dataVal) => {
          if (dataVal) {
            this.setClsValues(dataVal);
            this.flyOutLanguageSelectorContent$ = of({
              searchLabel: this.searchLabel,
              searchPlaceholder: this.searchPlaceholder,
              location: this.location,
              region: this.region,
              title: this.title,
              currentCountryCode: this.currentCountryCode,
              currentCLSLanguage: this.currentCLSLanguage,
              clsLanguageCodeToChange: this.clsLanguageCodeToChange,
              displayButtonText: this.displayButtonText,
              countryLanguageList: this.countryLanguageList,
              regionList: this.regionList,
              searchRegionList: this.searchRegionList,
              selectedRegion: this.selectedRegion,
              selectedRegionCountries: this.selectedRegionCountries,
              indexArray: this.indexArray
            });
          }
        });
    });
    if (this.appconfig.onBrowser) {
      this.deviceTypes = this._deviceTypeHelper.getDeviceType();
    }
  }

  updateShowModal(): void {
    this.showSelectorModal.set(false);
    //this.init();
  }

  setClsValues(data: string): void {
    data = data.toLowerCase();
    const res = data.split('-');
    this.currentCountryCode = res[1];
    this.currentCLSLanguage = res[0];
    this.setDisplayButtonText(this.currentCLSLanguage);
    if (res[0] != 'en') {
      this.clsLanguageCodeToChange = 'en';
    }
    this.setTitle(this.currentCLSLanguage);
    this.setRegion(this.currentCLSLanguage);
    this.setLocation(this.currentCLSLanguage);
    this.setPlaceHolder(this.currentCLSLanguage);
    this.setSearchLabel(this.currentCLSLanguage);
  }

  onRegionClicked(value: RegionData): void {
    this.evaluateIndex(value);
    this.selectedRegion = value.region;
    this.selectedRegionCountries = this.countryLanguageList.filter((item) => {
      return value.region.region_codes.indexOf(item.regionCode) !== -1;
    });
    if (value.flow === 'event') {
      this.flyOutLanguageSelectorContent$.subscribe((content) => {
        this.flyOutLanguageSelectorContent$ = of({
          ...content,
          selectedRegion: this.selectedRegion,
          selectedRegionCountries: this.selectedRegionCountries,
          indexArray: this.indexArray
        });
      });
    }
  }

  onSearchValueChanged(searchValue: string): void {
    let minLength = 2;
    const match = searchValue.match(/^[a-zA-Z ]+$/);
    if (match) {
      minLength = 3;
    }
    this.setSearchListSubject(searchValue, minLength);
  }

  setSearchListSubject(searchValue: string, minLength: number): void {
    if (searchValue && searchValue !== '' && searchValue.length >= minLength) {
      this.setSearchCountryList(searchValue);
    } else {
      this.searchList$ = of();
    }
  }

  afterLanguageSelected(value: {
    languageCode: string;
    countryCode: string;
  }): void {
    let prefvalue = '';
    prefvalue = value.languageCode + '-' + value.countryCode;
    this.cookieHelper.setCookies('prefUI', prefvalue);
    this.showSelectorModal.set(false);
    document.getElementsByTagName('html')[0].classList.remove('no-scroll');
    this.countryLanguageHelper.redirectToTranslatedSitesForContentPages(
      value.countryCode,
      value.languageCode
    );
  }
}
